import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { pillars } from '../../data/whatYouGet';
export function WhatYouGet() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-267" data-mp="143gjy1emab8g">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-268" data-mp="100trpze1aoaq">
        <SectionTag icon="🎁" data-id="element-269" data-mp="zzillsx494gg">Lo que recibes hoy (Acceso Inmediato)</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-270" data-mp="1dza6mdm1vl3y">
          Todo lo que necesitas, en un solo lugar.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-271" data-mp="1nqwimc67po7r">
          Más de 150 sesiones para que preparar el entrenamiento deje de comerse tu tiempo.
        </p>
        <p className="mt-2 text-sm font-medium text-lime" data-id="element-272" data-mp="1wqta0ljzl16i">
          Más de 150 sesiones · 6 Tomos · +10 Meses de entrenamiento · 100% Digital
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-5xl gap-6 px-4 sm:px-6 lg:grid-cols-2" data-id="element-273" data-mp="1rtt0g0nxhgan">
        {pillars.map((pillar, i) => <m.div key={pillar.title} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        delay: i % 2 * 0.1
      }} className="flex flex-col rounded-2xl border border-white/10 bg-bg-secondary p-6 sm:p-7" data-id="element-274" data-mp="2zxov5djhidn1" data-mpi={i}>
            <div className="flex items-start justify-between gap-3" data-id="element-275" data-mp="3dwwuq7jk7nrr">
              <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-lime/10" data-id="element-276" data-mp="3ivra0zibiu74">
                <pillar.icon size={22} className="text-lime" data-id="element-277" data-mp="3noapy34ha1f3" />
              </div>
              <span className="rounded-full bg-white/5 px-3 py-1 text-xs font-semibold text-muted" data-id="element-278" data-mp="3smlymaj1e5vq">
                {pillar.tag}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-lg font-semibold leading-snug text-white sm:text-xl" data-id="element-279" data-mp="1e875t8yp9z5">
              {pillar.title}
            </h3>
            <div className="mt-2 flex items-baseline gap-2 text-sm" data-id="element-280" data-mp="22jbvq117xqxo">
              <span className="text-muted line-through" data-id="element-281" data-mp="1xjpm01klmstm">Valor: {pillar.value}</span>
              <span className="font-semibold text-success" data-id="element-282" data-mp="2bakngssrq7n6">{pillar.today}</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-283" data-mp="26jvv7b99l6mz">{pillar.lead}</p>
            <ul className="mt-4 space-y-2.5" data-id="element-284" data-mp="26hrkoagv19dq">
              {pillar.items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-white/90" data-id="element-285" data-mp="2lav1ugqjhl3x">
                  <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-success" data-id="element-286" data-mp="2gc1lmgjvbg02" />
                  <span data-id="element-287" data-mp="2u8nete8sggo5">{item}</span>
                </li>)}
            </ul>
          </m.div>)}
      </div>
    </section>;
}